/* eslint-disable react/jsx-no-bind */
import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Formik, Form} from 'formik';
import {FormattedMessage, useIntl} from 'react-intl';
import messages from '../../../res/translations/messages';
import Yup from '../../yup';
import FormGroupRadio from './FormGroupRadio';
import {INSTANCE_FILTERS} from '../../constants';

const SurveyDownloadSchema = Yup.object().shape({
    format: Yup.string().required(),
    instanceType: Yup.string().oneOf(Object.values(INSTANCE_FILTERS)).required(),
});

const SurveyDownloadModal = ({isOpen, toggle, initialValues, onSubmit, submitting, surveyCompleted, surveyStarted}) => {
    const intl = useIntl();

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                <FormattedMessage {...messages.surveys.modals.download.title} />
            </ModalHeader>

            <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={SurveyDownloadSchema}>
                {({values, setFieldValue}) => {
                    const handleInstanceTypeChange = (e) => setFieldValue('instanceType', e.target.value);

                    return (
                        <Form>
                            <ModalBody>
                                <label>
                                    <FormattedMessage {...messages.surveys.modals.download.format} />
                                </label>

                                <div role="group">
                                    <FormGroupRadio
                                        id="sdm-excel"
                                        icon={['far', 'file-excel']}
                                        name="format"
                                        value="excel"
                                        label={messages.surveys.modals.download.downloadExcel}
                                    />

                                    <FormGroupRadio
                                        id="sdm-csv"
                                        icon="file-csv"
                                        name="format"
                                        value="csv"
                                        label={messages.surveys.modals.download.downloadCsv}
                                    />
                                </div>

                                <div className="col-auto">
                                    <label className="mt-4">
                                        <FormattedMessage {...messages.surveys.modals.download.instanceType} />
                                    </label>

                                    <select
                                        className="form-control"
                                        name="instanceType"
                                        value={values.instanceType || INSTANCE_FILTERS.COMPLETED}
                                        onChange={handleInstanceTypeChange}
                                    >
                                        {Object.values(INSTANCE_FILTERS).filter((val) => {
                                            if (val === INSTANCE_FILTERS.ALL && (surveyCompleted === 0 || surveyStarted === 0)) {
                                                return false;
                                            }
                                            if (val === INSTANCE_FILTERS.NOT_COMPLETED && surveyStarted === 0) {
                                                return false;
                                            }
                                            if (val === INSTANCE_FILTERS.COMPLETED && surveyCompleted === 0) {
                                                return false;
                                            }
                                            return true;
                                        }).map((val) => (
                                            <option key={val} value={val}>
                                                {intl.formatMessage({id: `surveys.modals.download.${val}`, defaultMessage: val})}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </ModalBody>

                            <ModalFooter>
                                <button className="btn btn-outline-secondary mr-auto" type="button" onClick={toggle}>
                                    <FormattedMessage {...messages.buttons.cancel} />
                                </button>

                                <button className="btn btn-primary" type="submit" disabled={submitting}>
                                    <FormattedMessage {...messages.buttons.ok} />
                                </button>
                            </ModalFooter>
                        </Form>
                    );
                }}
            </Formik>
        </Modal>
    );
};

export default SurveyDownloadModal;
